import React from "react";

function TableStatus({ text }) {
  const textx = text?.toLowerCase();

  // centralized status color mapping
  const statusStyles = {
    // Generic boolean handling
    true: { color: "#12A474", bg: "#BBF3E0", label: "Yes" },
    false: { color: "#EB5757", bg: "#FFDBDB", label: "No" },

    // smsStatus
    success: { color: "#12A474", bg: "#BBF3E0" },
    failed: { color: "#EB5757", bg: "#FFDBDB" },
    not_sent: { color: "#F2994A", bg: "#FFF3DB" },

    // PaymentStatus
    ongoing: { color: "#F2994A", bg: "#FFF3DB" },
    completed: { color: "#12A474", bg: "#BBF3E0" },
    cancelled: { color: "#828282", bg: "#E0E0E0" },

    // PayoutStatus
    pending: { color: "#F2994A", bg: "#FFF3DB" },
    // ongoing already covered above
    // completed already covered above
    // failed already covered above
  };

  const style = statusStyles[textx] || {
    color: "#12A474",
    bg: "#BBF3E0",
  };

  return (
    <span
      style={{
        backgroundColor: style.bg,
        color: style.color,
        fontSize: 12,
        padding: "5px 10px",
        borderRadius: 8,
        textTransform: "capitalize",
      }}
    >
      {style.label || text}
    </span>
  );
}

export default TableStatus;
